import React, { useCallback, useState } from "react";
import { useMutation, gql } from "@apollo/client";
import { useDropzone } from "react-dropzone";
import { ReactComponent as CloseButton } from "../../../styles/closeButton.svg";

export default function UpdateFacility({ isOpen, onClose }: any) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  
  if (!isOpen) return null;
  
  return (
    <div className="file-upload_modal">
      <div className="file-upload_modal_backdrop" onClick={onClose}></div>

      <div className="file-upload_modal_box">
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <CloseButton />
        </div>

        <p>Update Facility</p>
        {/* Your fields here */}
      </div>
    </div>
  );
}